<!-- 
    描述：考核记录详情页
	asq

    step1:
    编辑于      2021-3-18
    编辑人      王帅
    编辑内容:   1. 优化调整 上方文字信息显示
               2. 下方 考核结果 替换 
    updated by 钱磊 2022-5-18 11:05:04
-->
<template>
    <div class="filed-info-layout">
        <div class="common-top" ref="formRef">
            <div class="text-right pdt10 hidden">
                <el-button type="primary" class="btn-blue" @click="goBack" size="small"
                    >返回</el-button
                >
            </div>
            <div class="card-area">
                <el-form :model="detailData" label-width="140px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="流水号：">
                                <div class="text-overflow">
                                    {{ detailData.serialNo ? detailData.serialNo : "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="考核时间：">
                                <div class="text-overflow">
                                    {{
                                        detailData.createDate
                                            ? detailData.createDate
                                            : "-"
                                    }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="考核引用规则：">
                                <div class="text-overflow">{{ code ? code : "-" }}</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="考核对象：">
                                <div class="text-overflow">
                                    {{
                                        detailData.markObjName
                                            ? detailData.markObjName
                                            : "-"
                                    }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="对象名称：">
                                <div class="text-overflow">
                                    {{ detailData.objName ? detailData.objName : "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="业务来源：">
                                <div class="text-overflow">
                                    {{
                                        detailData.sourceName
                                            ? detailData.sourceName
                                            : "-"
                                    }}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="考核人：">
                                <div class="text-overflow">
                                    {{ detailData.judger ? detailData.judger : "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="考核人角色：">
                                <div class="text-overflow">
                                    {{
                                        detailData.judgeRoleName
                                            ? detailData.judgeRoleName
                                            : "-"
                                    }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="考核人主体类型：">
                                <div
                                    class="text-overflow"
                                    v-if="detailData.judgeType !== null"
                                >
                                    {{ detailData.judgeType == 1 ? "企业" : "个人" }}
                                </div>
                                <div class="text-overflow" v-else>-</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="考核人所属单位：">
                                <div class="text-overflow">
                                    {{ detailData.unitName ? detailData.unitName : "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="被考核人：">
                                <div class="text-overflow">
                                    {{ detailData.beJudger ? detailData.beJudger : "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="被考核人角色：">
                                <div class="text-overflow">
                                    {{
                                        detailData.beJudgeRoleName
                                            ? detailData.beJudgeRoleName
                                            : "-"
                                    }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="被考核人主体类型：">
                                <div
                                    class="text-overflow"
                                    v-if="detailData.beJudgeType !== null"
                                >
                                    {{ detailData.beJudgeType == 1 ? "企业" : "个人" }}
                                </div>
                                <div class="text-overflow" v-else>-</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="被考核人所属单位：">
                                <div class="text-overflow">
                                    {{ detailData.unitName ? detailData.unitName : "-" }}
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <el-row>
            <el-divider content-position="left">考核卡</el-divider>
        </el-row>
        <div class="table">
            <vxe-table
                ref="xTable"
                :data="filterData"
                height="100%"
                size="small"
                :span-method="mergeRowMethod"
                highlight-current-row
                border
            >
                <vxe-table-column
                    type="seq"
                    title="序号"
                    align="center"
                    width="80"
                ></vxe-table-column>
                <vxe-table-column
                    field="typeName"
                    title="类别"
                    align="center"
                    show-overflow-tooltip
                    width="180"
                ></vxe-table-column>
                <vxe-table-column
                    field="sname"
                    title="名称"
                    align="center"
                    width="200"
                ></vxe-table-column>
                <vxe-table-column
                    field="content"
                    title="内容"
                    show-overflow-tooltip
                    align="center"
                    min-width="140"
                ></vxe-table-column>
                <vxe-table-column
                    field="standard"
                    title="考核标准"
                    align="center"
                    show-overflow-tooltip
                    width="200"
                ></vxe-table-column>
                <vxe-table-column
                    field="singleScore"
                    title="单项满分值"
                    align="center"
                    width="120"
                ></vxe-table-column>
                <vxe-table-column
                    field="remark"
                    title="备注"
                    show-overflow-tooltip
                    header-align="center"
                    align="left"
                    width="240"
                ></vxe-table-column>
                <vxe-table-column
                    field="score"
                    title="考核"
                    align="center"
                    width="120"
                ></vxe-table-column>
                <vxe-table-column
                    field="comment"
                    title="考核语"
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    width="240"
                ></vxe-table-column>
            </vxe-table>
        </div>
        <div class="tip">
            <p class="show-total">总分： {{ totalScore }}分</p>
            <p>
                合计考核：<span class="text-border"
                    >{{ detailData.score }}分</span
                >
                考核结果：<span class="text-border"
                    ><span :style="{ color: resultInfo.color, fontSize: '16px',marginRight: '3px' }">★</span
                    >{{ resultInfo.text }}</span
                >
            </p>
            <p class="info-color">{{ resultTips }}</p>
        </div>
    </div>
</template>
<script>
import { getRecordsDetail } from "api/modules/evaluate-system/EvaluateRecords";
export default {
    data() {
        return {
            detailData: {},
            filterData: [],
            code: "",
            markResult: [],
            totalScore: 100,
        };
    },
    created() {
        if (this.$getSessionItem("detailData")) {
            this.detailData = JSON.parse(this.$getSessionItem("detailData"));
        }
        this.getData();
    },
    methods: {
        // 通用行合并函数（将相同多列数据合并为一行）
        mergeRowMethod({ row, _rowIndex, column, visibleData }) {
            // 定义要合并的 列 属性数组
            const fields = ["typeName"];
            const cellValue = row[column.property];
            // 如果是 合并的那列 且有数据
            if (cellValue && fields.includes(column.property)) {
                // 上一行
                const prevRow = visibleData[_rowIndex - 1];
                // 下一行
                let nextRow = visibleData[_rowIndex + 1];

                // 如果上一行存在 且 数据和当前行相同
                if (prevRow && prevRow[column.property] === cellValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let countRowspan = 1;
                    while (nextRow && nextRow[column.property] === cellValue) {
                        nextRow = visibleData[++countRowspan + _rowIndex];
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 };
                    }
                }
            }
        },
        // 返回
        goBack() {
            this.$router.push({ path: "/evaluate-records" });
        },

        getData() {
            let arr = {
                id: this.$route.query.id,
            };
            getRecordsDetail(arr)
                .then((res) => {
                    this.filterData = res.data.resList;
                    this.markResult = res.data.markResult;
                    this.totalScore = res.data.totalScore;
                    this.code = res.data.code;
                })
                .catch((err) => {});
        },
    },
    computed: {
        // 考核结果 提示文案
        resultTips() {
            let str = "提示：考核结果 ";
            this.markResult.map((x) => {
                str = str + `${x.min}-${x.max}分 为${x.title}, `;
            });
            str = str.slice(0, str.length - 2);
            return str;
        },

        // 考核结果颜色 + 文字
        resultInfo() {
            let obj = {
                color: "",
                text: "",
            };
            switch (parseFloat(this.detailData.markResult)) {
                case 0:
                    obj = {
                        color: "red",
                        text: "差考核",
                    };
                    break;
                case 1:
                    obj = {
                        color: "orange",
                        text: "良好",
                    };
                    break;
                case 2:
                    obj = {
                        color: "green",
                        text: "优秀",
                    };
                    break;
                case 3:
                    obj = {
                        color: "purple",
                        text: "完美",
                    };
                    break;
            }
            return obj;
        },
    }
};
</script>
<style lang="less" scoped>
.filed-info-layout {
    height: 100%-1000px;

    .color-blue {
        color: #256fc8;
        font-style: normal;
    }
    
    .common-top {
        // padding: 20px 0 0 0;
        text-align: right;

        .card-area {
            margin-top: 15px;
            line-height: 35px;
            margin-left: 30px;
            font-size: 14px;
            .text-overflow {
                text-align: left;
            }
        }
    }
    .table {
        margin-top: 0px;
        height: 510px;
        text-align: center;
        overflow: auto;
    }
    .tip {
        padding: 5px 0;

        .show-total {
            font-size: 16px;
        }

        p {
            padding-left: 5px;
            font-size: 14px;
            // border-left: 4px solid #2672cc;
        }

        .info-color {
            color: #256fc8;
        }

        .text-border {
            margin-right: 10px;
            border-bottom: 1px solid #666;
            font-size: 14px;
        }
    }

    .card-area {
        /deep/ .el-form-item {
            margin-bottom: 0;
        }

        /deep/ .el-form-item__label {
            line-height: 35px;
            padding-right: 5px;
        }

        /deep/ .el-form-item__content {
            line-height: 35px;
        }
    }
}
</style>
<style lang="less">
.table {
    .vxe-table__empty-block {
        min-height: 433px;
        text-align: center;
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
    .vxe-table--scrollable-x .vxe-table__body-wrapper {
        overflow-x: auto;
        height: 440px;
    }
}
</style>
